module.exports = __webpack_public_path__ + "static/media/food-court-ramen1.a409adcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/structures/food-court-ramen1.png
// module id = 133
// module chunks = 0